//
//
//
//
//
//
//
//
//

import NewsItem from './NewsItem';
import BusinessItem from './BusinessItem';

export default {
	name: "ImageListItem",
		props: ["item"],
		components: {
			appNewsItem: NewsItem,
			appBusinessItem: BusinessItem
		},
    computed: {
			itemComponentType: function() {
				switch (this.item.contentType.id) {
					case "Ahla.Business":
						return "app-business-item";
					case "Ahla.PublicationAlert":
					case "Ahla.PublicationBriefing":
					case "Ahla.PublicationBulletin":
					case "Ahla.Article":
					case "Ahla.DailyNews":
					case "Ahla.HealthLawWeeklyArticle":
					default:
						return "app-news-item";
				}
			}
    }
};
